export const FUNDING_STAGES = [
  "Pre-seed",
  "Seed",
  "Angel",
  "Series A",
  "Series B",
  "Venture Capital",
  "Mezzanine financing and bridge loans",
  "Initial Public Offering",
  "IPO (Initial Public Offering)",
];
